module.exports = __webpack_public_path__ + "img/t6.f9a27822.jpg";